import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import {
  ObservationDefinition,
  ObservationDefinitionReference,
} from 'app/mdm/lib/observation-definition/observation-definition';
import { TranslateService } from '@ngx-translate/core';
import { insertAtCursor } from '@heda/core-util/util/input.util';

@Component({
  selector: 'hw-observation-definition-range-hint',
  templateUrl: 'observation-definition-range-hint.component.html',
  styles: [
    `
      nz-alert {
        margin-bottom: 15px;
      }

      strong {
        cursor: pointer;
      }

      .reference-line {
        display: flex;
        align-items: center;
      }

      .reference-selects {
        margin-left: 10px;
        min-width: 10%;
      }
    `,
  ],
})
export class ObservationDefinitionRangeHintComponent {
  @Input() public name: string;
  @Input() public input: string;
  @Input() public includeVal: boolean;
  @Input() public definition: ObservationDefinition;

  @Output() public inputChange: EventEmitter<string> = new EventEmitter<string>();
  @ViewChild('textArea') private textArea: ElementRef;
  public rangeHints = {};

  constructor(private translateService: TranslateService) {}

  public insertAtCursor(code?: string): void {
    const _code = code ? 'refs["' + code + '"]' : 'val';
    this.insertIntoElement(_code);
  }

  public insertIntoElement(code: string): void {
    const val = insertAtCursor(this.textArea.nativeElement, code);
    this.inputChange.emit(val);
  }

  public addValue(value: any, code: string): void {
    this.insertIntoElement('"' + value + '"');
    setTimeout(() => delete this.rangeHints[code], 0);
  }

  public toDefinitions(references: ObservationDefinitionReference[]): ObservationDefinition[] {
    return references.map((r) => r.definitionReference).filter(Boolean);
  }

  public formatReferenceLine = (reference: ObservationDefinition): string => {
    return (
      reference.names[this.translateService.currentLang] +
      ' ' +
      (reference.defaultUnit?.alias ? ', ' + reference.defaultUnit.alias[this.translateService.currentLang] : '') +
      (reference.dataType ? ' (' + reference.dataType.code + ')' : '')
    );
  };
}
